import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';

function EntryView({ onPassword }) {

	const [password,setPassword] = React.useState("");

	function handleChange(e) {
		//console.log("handleChange");
		let updatedPassword = e.target.value;
		setPassword(updatedPassword);
	}

/*
	function handleKeyPress(e) {
		//console.log("handleKeyPress");
		if (e.key === 'Enter') {
			onPassword(password);
			e.preventDefault();
		}
	}
*/

	function handleOk(e) {
		//console.log("handleOk");
		if (onPassword) {
			onPassword(password);
			e.preventDefault();
		}
	}

	return (
		<Box
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			sx={{ width:'100vw', height: '100vh' }}
		>
			<Typography
				sx={{
					//marginTop: `${200/360 * 100}vw`,
					fontFamily: '노토산스 Bold',
					fontSize: `${22/360 * 100}vw`,
					color: '#000000',
				}}
			>
				보안 콘텐츠
			</Typography>
			<Typography
				sx={{
					marginTop: `${10/360 * 100}vw`,
					fontFamily: '노토산스 Regular',
					fontSize: `${12.5/360 * 100}vw`,
					color: '#555555',
				}}
			>
				비밀번호를 입력하세요.
			</Typography>
			<TextField
				sx={{
					marginTop: `${20/360 * 100}vw`,
					width: `${267/360 * 100}vw`,
					height: `${43/360 * 100}vw`,
				}}
				label="비밀번호"
				variant="outlined"
				margin="normal"
				type="password"
				value={password}
				onChange={handleChange}
			/>
			<Button
				variant="outlined"
				sx={{
					marginTop: `${20/360 * 100}vw`,
					bgcolor: '#6cadff',
					border: `${1/360 * 100}vw solid #6cadff`,
					borderRadius: `${15/360 * 100}vw`,
					width: `${107/360 * 100}vw`,
					height: `${35/360 * 100}vw`,
				}}
				onClick={handleOk}
			>
				<Typography
					fontFamily='노토산스 Medium'
					fontSize={`${14/360 * 100}vw`}
					color='#ffffff'
					sx={{margin:'-10px'}}
				>
					확 인	
				</Typography>
			</Button>
		</Box>
	);
}

export default EntryView;
